// src/components/DynamicReportInputs/ProgramIdSelector.js
import React from "react";
import GenericSelector from "./GenericSelector";

export const PROGRAM_ID_OPTIONS = [
  { value: 1, label: "Receta Solidaria" },
  { value: 2, label: "Solo Mujer" },
  { value: 3, label: "GES" },
  { value: 4, label: "Mi Salcobrand" },
  { value: 5, label: "Crónicos Ahumada" },
  { value: 6, label: "Club + Cruz Verde" },
];

export default function ProgramIdSelector({
  value,
  onChange,
  error = null,
  required = false,
  label = "Programa",
}) {
  return (
    <GenericSelector
      label={label}
      value={value}
      onChange={onChange}
      options={PROGRAM_ID_OPTIONS}
      error={error}
      required={required}
    />
  );
}
